// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExplorerClub_entry-container__akrL7{
    width: 100vw;
    height: 50vw;
    margin-top: -5vw;
}

.ExplorerClub_entry-img__G5F36{
    position: absolute;
    width: 100vw;
    height: 50vw;
    object-fit: cover;
}

.ExplorerClub_entry-heading__K1e4X{
    position: absolute;
    font-size: 5vw;
    margin-top: 13vw;
    margin-left: 8vw;
    width: 35vw;
    font-family: dm-sans-medium;
}

.ExplorerClub_entry-desc__pR5Od{
    position: absolute;
    font-size: 1.3vw;
    margin-top: 27vw;
    margin-left: 8vw;
    font-family: dm-sans-medium;
}

.ExplorerClub_perks-heading__eVEHE{
    text-align: center;
    /* font-size: 44px; */
    font-size: 3.2vw;
    margin-bottom: 0;
    font-family: dm-sans-medium;
}

.ExplorerClub_underline__4li\\+U{
    color: rgb(230, 84, 57);
    font-size: 3vw;
    text-align: center;
    margin-top: -2.5vw;
    margin-bottom: 0px;
    font-family: sans-serif;
}

.ExplorerClub_grid-perks__VGoHG{
    display: grid;
    justify-content: center;
    text-align: center;
    place-content: center;
    margin-top: 5vw;
    grid-template-columns: 30vw 30vw 30vw;
    row-gap: 6vw;
    margin-bottom: 5vw;
}

.ExplorerClub_perk__a7kII{
    display: flex;
    flex-direction: column;
}

.ExplorerClub_after-card-margin__F9NLL{
    width: 100vw;
    height: 3vw;
}

@media(max-width: 768px){
    .ExplorerClub_entry-container__akrL7{
        width: 100vw;
        height: 79vw;
        margin-top: -13vw;
    }
    
    .ExplorerClub_entry-img__G5F36{
        position: absolute;
        width: 100vw;
        height: 79vw;
        object-fit: cover;
    }
    
    .ExplorerClub_entry-heading__K1e4X{
        position: absolute;
        font-size: 6vw;
        margin-top: 17vw;
        margin-left: 8vw;
        width: 45vw;
    }
    
    .ExplorerClub_entry-desc__pR5Od{
        position: absolute;
        font-size: 2.7vw;
        margin-top: 33vw;
        margin-left: 8vw;
    }
    
    .ExplorerClub_perks-heading__eVEHE{
        text-align: center;
        /* font-size: 44px; */
        font-size: 6vw;
        margin-bottom: 0;
    }
    
    .ExplorerClub_underline__4li\\+U{
        color: rgb(230, 84, 57);
        font-size: 5vw;
        text-align: center;
        margin-top: -3vw;
        margin-bottom: 8vw;
        font-family: serif;
    }
    
    .ExplorerClub_grid-perks__VGoHG{
        display: grid;
        /* justify-content: center; */
        text-align: center;
        place-content: center;
        margin-top: -3vw;
        grid-template-columns: 50vw 50vw;
        row-gap: 6vw;
        margin-bottom: 10vw;
    }
    
    .ExplorerClub_perk__a7kII{
        display: flex;
        flex-direction: column;
    }

    .ExplorerClub_after-card-margin__F9NLL{
        height: 10vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/ExplorerClub/ExplorerClub.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,qCAAqC;IACrC,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;QACrB,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,cAAc;QACd,kBAAkB;QAClB,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,6BAA6B;QAC7B,kBAAkB;QAClB,qBAAqB;QACrB,gBAAgB;QAChB,gCAAgC;QAChC,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".entry-container{\n    width: 100vw;\n    height: 50vw;\n    margin-top: -5vw;\n}\n\n.entry-img{\n    position: absolute;\n    width: 100vw;\n    height: 50vw;\n    object-fit: cover;\n}\n\n.entry-heading{\n    position: absolute;\n    font-size: 5vw;\n    margin-top: 13vw;\n    margin-left: 8vw;\n    width: 35vw;\n    font-family: dm-sans-medium;\n}\n\n.entry-desc{\n    position: absolute;\n    font-size: 1.3vw;\n    margin-top: 27vw;\n    margin-left: 8vw;\n    font-family: dm-sans-medium;\n}\n\n.perks-heading{\n    text-align: center;\n    /* font-size: 44px; */\n    font-size: 3.2vw;\n    margin-bottom: 0;\n    font-family: dm-sans-medium;\n}\n\n.underline{\n    color: rgb(230, 84, 57);\n    font-size: 3vw;\n    text-align: center;\n    margin-top: -2.5vw;\n    margin-bottom: 0px;\n    font-family: sans-serif;\n}\n\n.grid-perks{\n    display: grid;\n    justify-content: center;\n    text-align: center;\n    place-content: center;\n    margin-top: 5vw;\n    grid-template-columns: 30vw 30vw 30vw;\n    row-gap: 6vw;\n    margin-bottom: 5vw;\n}\n\n.perk{\n    display: flex;\n    flex-direction: column;\n}\n\n.after-card-margin{\n    width: 100vw;\n    height: 3vw;\n}\n\n@media(max-width: 768px){\n    .entry-container{\n        width: 100vw;\n        height: 79vw;\n        margin-top: -13vw;\n    }\n    \n    .entry-img{\n        position: absolute;\n        width: 100vw;\n        height: 79vw;\n        object-fit: cover;\n    }\n    \n    .entry-heading{\n        position: absolute;\n        font-size: 6vw;\n        margin-top: 17vw;\n        margin-left: 8vw;\n        width: 45vw;\n    }\n    \n    .entry-desc{\n        position: absolute;\n        font-size: 2.7vw;\n        margin-top: 33vw;\n        margin-left: 8vw;\n    }\n    \n    .perks-heading{\n        text-align: center;\n        /* font-size: 44px; */\n        font-size: 6vw;\n        margin-bottom: 0;\n    }\n    \n    .underline{\n        color: rgb(230, 84, 57);\n        font-size: 5vw;\n        text-align: center;\n        margin-top: -3vw;\n        margin-bottom: 8vw;\n        font-family: serif;\n    }\n    \n    .grid-perks{\n        display: grid;\n        /* justify-content: center; */\n        text-align: center;\n        place-content: center;\n        margin-top: -3vw;\n        grid-template-columns: 50vw 50vw;\n        row-gap: 6vw;\n        margin-bottom: 10vw;\n    }\n    \n    .perk{\n        display: flex;\n        flex-direction: column;\n    }\n\n    .after-card-margin{\n        height: 10vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entry-container": `ExplorerClub_entry-container__akrL7`,
	"entry-img": `ExplorerClub_entry-img__G5F36`,
	"entry-heading": `ExplorerClub_entry-heading__K1e4X`,
	"entry-desc": `ExplorerClub_entry-desc__pR5Od`,
	"perks-heading": `ExplorerClub_perks-heading__eVEHE`,
	"underline": `ExplorerClub_underline__4li+U`,
	"grid-perks": `ExplorerClub_grid-perks__VGoHG`,
	"perk": `ExplorerClub_perk__a7kII`,
	"after-card-margin": `ExplorerClub_after-card-margin__F9NLL`
};
export default ___CSS_LOADER_EXPORT___;
